<template>
  <div>
    <div class="row mb-3" v-if="!readonly">
      <div class="col-md-3 col-12">
        <div class="form-group form-group-sm">
          <v-label :metadata-field="metadata.compra.parcelas"></v-label>
          <div class="input-group input-group-sm">
            <select ref="parcelas" class="form-control" v-model="localQtParcelas" :disabled="readonly" @change="calculaParcelas">
              <option v-for="opt in parcelaOptions" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2 font-bold" v-if="value.length > 0">
      <div class="col-md-1 col-2 text-center">Nº</div>
      <div class="col-md-2 col-3">
        <v-label :metadata-field="metadata.comprapar.dias"></v-label>
      </div>
      <div class="col-md-2 col-4">
        <v-label :metadata-field="metadata.comprapar.dtvenc"></v-label>
      </div>
      <div class="col-md-3 col-3">
        <v-label :metadata-field="metadata.comprapar.valor"></v-label>
      </div>
      <div class="col-md-3 col-12">
        <v-label :metadata-field="metadata.comprapar.formapag"></v-label>
      </div>
    </div>

    <div class="row mb-2 align-items-center" v-for="(par, index) in value" :key="index">
      <div class="col-md-1 col-2 text-center">
        <span class="data-list">{{ index + 1 }}</span>
      </div>
      <form-field v-model="par.dias" type="number" col="2" :disabled="readonly || localQtParcelas === '0'" name="dias"
        :metadata="metadata.comprapar.dias" :nolabel="true" @input="updateDate(index)"></form-field>
      
      <form-field v-model="par.dtvenc" type="date" col="2" :disabled="readonly" name="dtvenc"
        :metadata="metadata.comprapar.dtvenc" :nolabel="true" @input="updateDays(index)"></form-field>
      
      <form-field v-model="par.valor" type="value" col="3" :precision="2" :disabled="readonly" name="valor"
        :metadata="metadata.comprapar.valor" :nolabel="true" @input="updatePercFromValue(index)"></form-field>

      <form-field v-model="par.formapag" type="select" col="3" :metadata="metadata.comprapar.formapag"
        :disabled="readonly" :nolabel="true" :optionnull="true"></form-field>

      <div class="col-md-1 col-3 text-right" v-if="!readonly">
        <v-button title="Remover" icon="fa-times" :danger="true" @click="handleRemoveParcela(index)"></v-button>
      </div>
    </div>

    <div class="row mt-3" v-if="value.length > 0">
      <div class="col-12 text-right">
        <span :class="totalDiff === 0 ? 'text-green' : 'text-red'">
          Diferença: R$ {{ totalDiff | formatValue(2, true) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatValue } from '../shared/utils'
import { arr } from '../shared/numbers'

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    readonly: Boolean,
    metadata: Object,
    qtParcelas: [Number, String]
  },
  data() {
    return {
      localQtParcelas: this.qtParcelas || '0'
    }
  },
  watch: {
    qtParcelas(newVal) {
      this.localQtParcelas = newVal || '0'
    },
    localQtParcelas(newVal) {
      this.$emit('update:qtParcelas', newVal)
    }
  },
  computed: {
    totalParcelas() {
      return (this.value || []).reduce((acc, p) => acc + (Number(p.valor) || 0), 0)
    },
    totalDiff() {
      return Number((this.total - this.totalParcelas).toFixed(2))
    },
    parcelaOptions() {
      if (this.metadata && this.metadata.compra && this.metadata.compra.parcelas) {
        return this.metadata.compra.parcelas.options
      }
      const opts = [{ id: '0', text: 'À Vista' }]
      for (let i = 1; i <= 36; i++) {
        opts.push({ id: String(i), text: `${i}x` })
      }
      return opts
    }
  },
  methods: {
    calculaParcelas() {
      const numParcelas = Number(this.localQtParcelas)
      let novasParcelas = []
      let vlr = 0
      const baseDate = new Date().toISOString().substr(0, 10)

      if (numParcelas === 0) {
        novasParcelas.push({
          parcela: 1,
          dtvenc: baseDate,
          valor: this.total,
          dias: 0,
          percentual: 100,
          formapag: ''
        })
      } else {
        for (let x = 1; x <= numParcelas; x++) {
          let parcela = {
            parcela: x,
            dtvenc: this.$addMonths(baseDate, x),
            dias: x * 30,
            percentual: Number((100 / numParcelas).toFixed(2)),
            formapag: ''
          }
          vlr = this.total
          vlr = arr(vlr / numParcelas, 2, true)
          parcela.valor = vlr
          novasParcelas.push(parcela)
        }
        
        // Fix rounding errors in the last installment
        const sum = novasParcelas.reduce((acc, p) => acc + (Number(p.valor) || 0), 0)
        if (sum !== this.total && novasParcelas.length > 0) {
          const diff = Number((this.total - sum).toFixed(2))
          novasParcelas[novasParcelas.length - 1].valor = Number((novasParcelas[novasParcelas.length - 1].valor + diff).toFixed(2))
        }
      }
      this.$emit('input', novasParcelas)
      this.$emit('change')
    },
    handleRemoveParcela(index) {
      const newValue = [...(this.value || [])]
      newValue.splice(index, 1)
      this.$emit('input', newValue)
      this.$emit('change')
    },
    updateDate(index) {
      const par = this.value[index]
      if (!par) return
      par.dtvenc = this.$addDays(new Date().toISOString().substr(0, 10), par.dias)
    },
    updateDays(index) {
      const par = this.value[index]
      if (!par) return
      par.dias = this.$daysBetween(new Date().toISOString().substr(0, 10), par.dtvenc)
    },
    updateValueFromPerc(index) {
      const par = this.value[index]
      if (!par) return
      par.valor = Number((this.total * (par.percentual / 100)).toFixed(2))
    },
    updatePercFromValue(index) {
      const par = this.value[index]
      if (!par) return
      par.percentual = this.total > 0 ? Number(((par.valor / this.total) * 100).toFixed(2)) : 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/compra-parcelas.vue